import React, { useState, useEffect } from "react";
import { useTransition, animated } from "react-spring";
import ThankYou from "./ThankYou";
import { red } from "@material-ui/core/colors";

export const HowCanWeReachYou = ({ formData, setForm, navigation, extraData }) => {
  const [error, setError] = useState("");
  const { email, phone } = formData;
  const [isVisible, setIsVisible] = useState(true);
  const [showThankYou, setShowThankYou] = useState(false);
  const [additionalFormData, setAdditionalFormData] = useState({});

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(300px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  let searchParams = new URLSearchParams(window.location.search);
  const [query, setQuery] = useState(window.location.search);

  useEffect(() => {
    const currentParams = Object.fromEntries([...searchParams]);

    delete currentParams.price;
    setQuery(currentParams);
  }, []);
  console.log(query);

  const submitForm = (linkStatus) => {
    let dataToSend = {
      ...query,
      ...formData,
      ...additionalFormData,
      ...extraData,
    };

    let link;
    let fetchOptions = {};

    // if its paul or tim we are sending to go high level
    if (extraData.ownerId === "005Po00000LzAZRIA3" && linkStatus === "redirectToApplication") {
      fetchOptions = {
        method: "POST",
        body: JSON.stringify(dataToSend),
        headers: {
          "Content-Type": "application/json",
        },
      };

      link =
        "https://services.leadconnectorhq.com/hooks/izUrdacuOqWXm18jERcB/webhook-trigger/29984f26-e1d8-44f3-a81a-1f56a2e0bcab";
    } else {
      link = "https://hooks.zapier.com/hooks/catch/5841802/2x9h2k0/";
      fetchOptions = {
        method: "POST",
        body: JSON.stringify(dataToSend),
        mode: "no-cors",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };
    }

    console.log(dataToSend);
    fetch(link, {
      method: "POST",
      body: JSON.stringify(dataToSend),
      mode: "no-cors",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => {
        console.log(response);
        if (window.parent !== window) {
          // We're in an iframe, redirect the parent window
          window.parent.location.href = extraData.applicationLink;
        } else {
          // We're not in an iframe, redirect normally
          window.location.href = extraData.applicationLink;
        }
        if (response.status === 0) {
          console.log("submitted");
          setShowThankYou(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  if (showThankYou) {
    return <ThankYou />;
  }

  const checkForNextStep = (linkStatus) => {
    setError("");
    if (!phoneValidator(formData.phone)) {
      setError("Please enter a valid phone number");
    } else if (!emailValidator(formData.email)) {
      setError("Please enter a valid email address");
    } else {
      setError("");
      submitForm(linkStatus);
    }
  };

  const emailValidator = (input) => {
    const regexpTest =
      /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isValid = regexpTest.test(input) && input.length > 0;

    return isValid;
  };

  function phoneValidator(input) {
    const regexpTest = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
    const isValid = input.length > 0 && regexpTest.test(input);

    return isValid;
  }

  function formatPhoneNumber(input) {
    var phoneNumber = input.replace(/\D/g, "");
    var match = phoneNumber.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      phoneNumber = "(" + match[1] + ") " + match[2] + "-" + match[3];
    }

    return phoneNumber;
  }

  console.log(formatPhoneNumber(formData.phone));

  return (
    <div className="flex flex-col h-screen">
      {/* <ProgressBar width={"100%"} /> */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center items-center">
        {transition((style, item) =>
          item ? (
            <animated.div style={style} className="mx-auto flex flex-col justify-center items-center pt-6">
              <h1 className="py-6 md:py-10 text-4xl text-blue-primary font-semibold text-center w-full">
                How can we reach you?
              </h1>
              <div className="flex justify-evenly flex-col space-y-8 mx-auto">
                <div>
                  <div className="flex justify-center items-center">
                    <input
                      name="phone"
                      value={formatPhoneNumber(formData.phone)}
                      onChange={setForm}
                      onBlur={() => setError("")}
                      id="phone"
                      type="tel"
                      maxLength="10"
                      className="shadow-sm border focus:ring-green-primary focus:border-green-primary block w-full text-xl font-semibold border-gray-300 rounded-md w-1/2 md:w-60 py-1 px-2"
                      placeholder="555-555-5555"
                    />
                    <label className="ml-6 text-xl font-semibold text-gray-satan">Phone Number</label>
                  </div>
                </div>
                <div className="">
                  <div className="flex justify-center items-center md:mr-4">
                    <input
                      name="email"
                      value={email}
                      onChange={setForm}
                      onBlur={() => setError("")}
                      id="email"
                      className="shadow-sm border focus:ring-green-primary focus:border-green-primary block w-full text-xl font-semibold border-gray-300 rounded-md w-1/2 md:w-60 py-1 px-2"
                      placeholder="email@email.com"
                    />
                    <label className="pr-16 text-xl font-semibold text-gray-satan ml-8 pl-0">Email</label>
                  </div>
                  <div className="text-center pt-4 md:pl-10 lg:mr-48">
                    {error && <p className="text-red-error">{error}</p>}
                  </div>
                  <div className="pt-10 lg:pt-12 flex-col space-y-6 md:space-y-0 flex md:flex-row justify-center items-center md:space-x-8">
                    <div>
                      <button
                        className="bg-red-button py-2 w-80 md:w-96 text-white font-bold outline-red-button outline-2 outline outline-offset-4 transition-all w-52 cursor-pointer hover:bg-red-error hover:outline-red-error"
                        onClick={() => checkForNextStep()}
                      >
                        Schedule a Consultation
                      </button>
                    </div>
                    <div>
                      <button
                        className="bg-magenta-button py-2 w-80 md:w-96 text-white font-bold outline-magenta-button outline-2 outline outline-offset-4 transition-all w-52 cursor-pointer hover:bg-magenta-darker hover:outline-magenta-darker"
                        onClick={() => checkForNextStep("redirectToApplication")}
                      >
                        Continue to Application
                      </button>
                    </div>
                  </div>
                </div>
                <p className="text-2xs lg:text-xs text-gray-fourdee text-center pb-36 md:pb-0 ">
                  By clicking the ‘Schedule a Consultation’ button above, I authorize CalCon Mutual Mortgage to contact
                  me using an automated dialing system, even if the telephone number is a cellular phone or other
                  service for which the party is charged. I understand that I am not required to provide this consent in
                  order to obtain goods or services from CalCon Mutual Mortgage. I agree to receive disclosures and
                  communications in electronic form and I confirm that I have a working computer system and an internet
                  website browser to view this webpage and this loan inquiry form. I agree that CalCon Mutual Mortgage
                  may contact me by mail, telephone (mobile devices including SMS and MMS) or email in connection with
                  my request even if my telephone number or email address appears on a CalCon Mutual Mortgage internal
                  Do Not Call / Do Not Email List, a State or National Do Not Call Registry, a Do Not E-Mail list, or
                  any other Do Not Contact List.
                </p>
              </div>
            </animated.div>
          ) : null
        )}
      </div>
    </div>
  );
};
